export default "__VITE_ASSET__01c9bef7__"